module.exports = __webpack_public_path__ + "img/1920_news_main_img3.f7dc159d.png";